import axios from 'axios'

export default {
  fetchCampaign (campaignId, callback) {
    var headers = {
      'x-api-key': process.env.VUE_APP_GATEWAY_API_KEY
    }
    if (campaignId) {
      headers['state'] = 'public'
      headers['id'] = campaignId
    }
    headers['ref'] = document.referrer
    if (document.URL.split('?', 2).length > 1) {
      headers['qs'] = document.URL.split('?', 2)[1]
    }
    axios.get(process.env.VUE_APP_GATEWAY_URL + '/public/campaign', { 'headers': headers })
      .then(r => r.data)
      .then(campaign => {
        callback(null, campaign)
      }).catch(error => {
        callback(error, null)
      })
  },
  postForm (accountId, campaignId, form, order, callback) {
    var headers = {
      'x-api-key': process.env.VUE_APP_GATEWAY_API_KEY,
      'state': 'public',
      'account_id': accountId,
      'id': campaignId
    }
    var payload = {}
    if (form) payload.form = form
    if (order) payload.order = order
    axios.post(process.env.VUE_APP_GATEWAY_URL + '/public/form', JSON.stringify(payload), { 'headers': headers })
      .then(r => r.data)
      .then(response => {
        callback(null, response)
      }).catch(error => {
        callback(error, null)
      })
  },
  processPayment (mode, accountId, desc, order, token, callback) {
    var headers = {
      'x-api-key': process.env.VUE_APP_GATEWAY_API_KEY,
      'state': 'public',
      'account_id': accountId
    }
    var payload = {}
    if (mode) payload.mode = mode
    if (token) payload.token = token
    if (order) payload.order = order
    if (desc) payload.desc = desc
    axios.post(process.env.VUE_APP_GATEWAY_URL + '/public/process', JSON.stringify(payload), { 'headers': headers })
      .then(r => r.data)
      .then(response => {
        callback(null, response)
      }).catch(error => {
        var errorText = 'There was an error while processing your card.'
        if (error.response) errorText = errorText + ' ' + error.response.data
        callback(errorText, null)
      })
  },
  updateOrder (accountId, campaignId, words, order, text, callback) {
    var headers = {
      'x-api-key': process.env.VUE_APP_GATEWAY_API_KEY,
      'state': 'public',
      'account_id': accountId,
      'id': campaignId
    }
    var payload = {}
    if (words) payload.words = words
    if (order) payload.order = order
    if (text) payload.text = text
    axios.put(process.env.VUE_APP_GATEWAY_URL + '/public/order', JSON.stringify(payload), { 'headers': headers })
      .then(r => r.data)
      .then(response => {
        callback(null, response)
      }).catch(error => {
        callback(error, null)
      })
  },
  unpublish (accountId, campaignId, callback) {
    var headers = {
      'x-api-key': process.env.VUE_APP_GATEWAY_API_KEY,
      'state': 'public',
      'account_id': accountId,
      'id': campaignId
    }
    var payload = {}
    axios.post(process.env.VUE_APP_GATEWAY_URL + '/public/up', JSON.stringify(payload), { 'headers': headers })
      .then(r => r.data)
      .then(response => {
        callback(null, response)
      }).catch(error => {
        callback(error, null)
      })
  }
}
